import React from "react";
import { useRecordContext } from "react-admin";
import { styled } from "@mui/material/styles";

const PaidText = styled("span")(({ theme }) => ({
  color: theme.palette.success.main,
}));

const UnpaidText = styled("span")(({ theme }) => ({
  color: theme.palette.warning.main,
}));

const PaymentStatus = () => {
  const record = useRecordContext();
  const paid = record?.paid ?? false;

  return paid ? <PaidText>Paid</PaidText> : <UnpaidText>Unpaid</UnpaidText>;
};

export default PaymentStatus;
